import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

/**
 * Shown in place of a settings list that has no rows yet, so an empty panel says
 * what is missing instead of reading as a loading failure.
 */
export default function SettingsEmptyState({ icon, title, description }) {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                gap: 1,
                px: 3,
                py: 6,
            }}
        >
            {icon && (
                <Box
                    aria-hidden="true"
                    sx={{
                        width: 52,
                        height: 52,
                        mb: 0.5,
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "rgba(0, 40, 128, 0.05)",
                        color: "rgba(0, 40, 128, 0.35)",
                        fontSize: "20px",
                    }}
                >
                    <i className={`pi ${icon}`} />
                </Box>
            )}
            <Typography
                sx={{
                    fontFamily: "roboto, sans-serif",
                    fontSize: "15px",
                    fontWeight: 600,
                    color: "rgba(45, 42, 38, 0.75)",
                }}
            >
                {title}
            </Typography>
            {description && (
                <Typography
                    sx={{
                        fontFamily: "roboto, sans-serif",
                        fontSize: "13px",
                        lineHeight: 1.5,
                        maxWidth: 380,
                        color: "rgba(45, 42, 38, 0.55)",
                    }}
                >
                    {description}
                </Typography>
            )}
        </Box>
    );
}
